import axios, { AxiosResponse } from "axios";

import { UPDATESURL, DOMIAN } from "../../shared/constants";
import { IAdminLogin } from "../../shared/dtos";
import { getCookie, removeAllCookies } from "./cookies";

const axiosInterceptor = axios.create({
  baseURL: UPDATESURL,
});

axiosInterceptor.interceptors.request.use(
  async (req) => {
    const token = getCookie("access_token");
    const userid = getCookie("userId");
    const deviceId = getCookie("deviceId");
    const source = getCookie("source") ? getCookie("source") : "WEB";

    req.headers.Authorization = `userId=${userid};deviceId=${deviceId};source=${source};finupdate_token=${token}`;
    return req;
  },
  (error) => Promise.reject(error),
);

axiosInterceptor.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response ? err.response.status : null;
    if (status === 401) {
      handleLogout();
    }
    return Promise.reject(err);
  },
);
const handleLogout = () => {
  removeAllCookies();
  setTimeout(() => {
    window.location.href = "/";
  }, 100);
};

export const GetProfileDetailsDDPIAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/api/V1/common/profile_details`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const CreateEsignPDFDDPIAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v2/api/ddpi/esign/create_pdf`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const EsignRequestDDPIAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v2/api/ddpi/esign/create_consent/`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const SaveEsignPdfDDPIAPICall = (requestBody: any) => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .post(`/v2/api/ddpi/esign_save_doc`, requestBody, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
export const GetStatusDDPIAPICall = () => {
  return new Promise((resolve, reject) => {
    axiosInterceptor
      .get(`/v2/api/ddpi/status`, {})
      .then((response: any) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
};
